import axios from 'axios';

const baseUrl = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:2045/api').replace(/\/+$/, '');

const httpRequest = async (endpoint, method = 'GET', data = null, params = null, responseType = 'json', isMultipart = false) => {
  try {
    const token = localStorage.getItem('token');
    const normalizedEndpoint = String(endpoint).replace(/^\/+/, '');

    const config = {
      method,
      url: `${baseUrl}/${normalizedEndpoint}`,
      data,
      params,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      responseType,
    };

    if (isMultipart) {
      delete config.headers['Content-Type'];
    }

    const response = await axios(config);

    return response.data;
  } catch (err) {
    throw err;
  }
};

export default httpRequest;
